import React from "react";
import { Outlet } from "react-router-dom";
import AuthenticatedLayout from "../../Layouts/AuthenticatedLayout";
import { GetLocalStorageByKey } from "../../Utils/BaseUtils";
import { NavTabs } from "./NavTabs";

const Configurations = (props: any) => {
    const hideTabsBool = GetLocalStorageByKey('hidetabs');

    return (
        <AuthenticatedLayout>
            { hideTabsBool ? null : <NavTabs />}
            <Outlet />
        </AuthenticatedLayout>
    );
};

export default Configurations;